import React from 'react';
import { ArrowUpRight, Clock3, MapPin } from 'lucide-react';

export default function MaintenancePage() {
	return (
		<main className="maintenance-page" data-testid="maintenance-page">
			<div className="maintenance-grid" aria-hidden="true" />
			<div className="maintenance-mark maintenance-mark-top" aria-hidden="true" />
			<div className="maintenance-mark maintenance-mark-bottom" aria-hidden="true" />

			<header className="maintenance-header">
				<a href="/" className="maintenance-brand" aria-label="Campo Aesernia">
					<img src="/img/aesernia_logo.png" alt="" />
					<span>AESERNIA</span>
				</a>
				<span className="maintenance-status">COMITATO DI ISERNIA</span>
			</header>

			<section className="maintenance-content">
				<div className="maintenance-copy">
					<div className="maintenance-eyebrow">
						<span className="maintenance-dot" />
						<span>AGGIORNAMENTO IN CORSO</span>
					</div>
					<h1>Torniamo<br /><em>presto.</em></h1>
					<p className="maintenance-lead">
						Il sito è momentaneamente in manutenzione. Stiamo preparando una nuova esperienza per il Campo Aesernia.
					</p>
					<a
						href="https://isernia.cri.it"
						target="_blank"
						rel="noopener noreferrer"
						className="maintenance-link"
						data-testid="isernia-committee-link"
					>
						<span>Visita il sito del Comitato di Isernia</span>
						<ArrowUpRight size={18} strokeWidth={2} />
					</a>
				</div>

				<div className="maintenance-panel" aria-label="Informazioni sul servizio">
					<div className="maintenance-cross" aria-hidden="true">
						<span />
						<span />
					</div>
					<div className="maintenance-panel-label">NEL FRATTEMPO</div>
					<div className="maintenance-panel-line" />
					<div className="maintenance-detail">
						<Clock3 size={17} />
						<span>Servizio temporaneamente sospeso</span>
					</div>
					<div className="maintenance-detail">
						<MapPin size={17} />
						<span>Isernia, Molise</span>
					</div>
					<div className="maintenance-panel-number">01<span>/01</span></div>
				</div>
			</section>

			<footer className="maintenance-footer">
				<span>CROCE ROSSA ITALIANA</span>
				<span>CAMPO AESERNIA</span>
				<span>© 2026</span>
			</footer>
		</main>
	);
}